import { createSelector, createSlice } from '@reduxjs/toolkit';
import moment from 'moment/moment';
import i18n from '../../translations/strings';

export enum EventType {
  Unavailability = 'Unavailability',
  CustomerEvent = 'CustomerEvent',
  ReadOnlyEvent = 'ReadOnlyEvent',
  MyPendingEvent = 'MyPendingEvent',
  SelectedDateEvent = 'SelectedDateEvent',
  // ReadOnlyCustomer = 'ReadOnlyCustomer'
}
export const EventPaymentMethod = [
  {
    id: 'PAYMENT_ON_SITE',
    name: i18n.t('booking.cashMethod')
  },
  {
    id: 'BANK_TRANSFER',
    name: i18n.t('booking.bankTransfer')
  },
]


const initialState: any = {
  loading: false,
  roomsAndServices: null,
  smartObjects: null,
  bookedIntervals: {}, // stored by room and dates interval
  myPendingEvents: {}, // stored by room and dates interval
  customerEvents: {}, // stored by room
  selectedDateEvent: {},
  events: {}, // stored by room and dates interval
  error: null,
  bookingSent: false,
};

export const getMonthKey = (monthDates: any) => `${monthDates.start}-${monthDates.end}`;

export const getEventsRefactor = (events: any) => {
  const customerEvents = events
  let interval: any = []
  Object.keys(customerEvents).map((key) => {
    interval = interval.concat(customerEvents[key])
  })
  interval = interval.filter((event: any) => !event.eventData?.check_in)
  interval = interval.filter((event: any) => !moment.utc(event.start).isBefore(moment().utc()))
  interval = interval.map((event: any) => {
    const services = event.services.length > 0 && typeof event.services[0] === 'string'
      ? event.services
      : event.services.map((service: any) => service.id)
    return {
      ...event,
      start: moment(new Date(event['start'])).format('YYYY-MM-DD HH:mm:ss'),
      end: moment(new Date(event['end'])).format('YYYY-MM-DD HH:mm:ss'),
      services: services
    }
  })
  return interval
}

const getRoomMonthEvents = (state: any, room: any, month: any) => {
  let roomMonthEvents: any[] = []
  if (state.bookedIntervals[room] && state.bookedIntervals[room][month]) {
    roomMonthEvents = roomMonthEvents.concat(state.bookedIntervals[room][month])
  }
  if (state.myPendingEvents[room] && state.myPendingEvents[room][month]) {
    roomMonthEvents = roomMonthEvents.concat(state.myPendingEvents[room][month])
  }
  if (state.selectedDateEvent[room] && state.selectedDateEvent[room][month]) {
    roomMonthEvents = roomMonthEvents.concat(state.selectedDateEvent[room][month])
  }
  if (state.customerEvents[room]) {
    roomMonthEvents = roomMonthEvents.concat(state.customerEvents[room])
  }
  return roomMonthEvents;
}

const slice = createSlice({
  name: 'makeReservation',
  initialState: initialState,
  reducers: {
    getRoomsAndServicesAction: state => {
      state.loading = true;
      state.error = null;
    },
    getRoomsAndServicesSuccessAction: (state, action) => {
      state.loading = false;
      state.error = null;
      state.roomsAndServices = action.payload.roomAndServices.data;
      state.smartObjects = action.payload.smartObject.data
    },
    getRoomsAndServicesErrorAction: (state, action) => {
      state.loading = false;
      state.roomsAndServices = null;
      state.smartObjects = null
      state.error = action.payload;
    },
    getSpecificRoomAndMonthBookedIntervalsAction: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getSpecificRoomAndMonthBookedIntervalsSuccessAction: (state, action) => {
      state.error = null;
      let bookedIntervalResponse =
        action.payload.bookedIntervalResponse.data.data;
      const room =
        bookedIntervalResponse.length > 0
          ? bookedIntervalResponse[0].product
          : null;
      if (room) {
        const month = action.payload.monthKey;
        const unavailabilityEvents: any[] = [];
        if (action.payload.reservation_id) {
          bookedIntervalResponse = bookedIntervalResponse.filter((booking: any) => booking.booking.id !== action.payload.reservation_id)
        }
        bookedIntervalResponse.map((item: any) => {
          let dateEnd = moment(item.end, 'YYYY-MM-DD HH:mm')
          if (dateEnd.isAfter()) {
            return unavailabilityEvents.push({
              title: 'Non disponibile',
              // title: item.booking.user_information.id === action.payload.user.id ? action.payload.user.full_name :  'Non disponibile',
              start: item.start,
              end: item.end,
              allDay: false,
              eventType: EventType.Unavailability,
              // eventType: item.booking.user_information.id === action.payload.user.id ? EventType.ReadOnlyCustomer : EventType.Unavailability,
              visibleRange: {
                start: moment.utc(item.start).local().format('HH:mm'),
                end: moment.utc(item.end).local().format('HH:mm'),
              },
            });
          }
        });
        state.bookedIntervals[room] = {
          ...state.bookedIntervals[room],
          [month]: unavailabilityEvents,
        };
        state.events[room] = {
          ...state.events[room],
          [month]: getRoomMonthEvents(state, room, month),
        };
      }
      state.loading = false;
    },
    getSpecificRoomAndMonthBookedIntervalsErrorAction: (state, action) => {
      state.loading = false;
      state.bookedIntervals = {};
      state.error = action.payload;
    },
    getSpecificRoomAndMonthCustomerDataAction: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getSpecificRoomAndMonthMyPendingEventsSuccessAction: (state, action) => {
      state.error = null;
      let myPendingEventResponse =
        action.payload.myPendingEventsResponse.data.data;
      const room =
        myPendingEventResponse.length > 0
          ? myPendingEventResponse[0].product
          : null;
      if (room) {
        const month = action.payload.monthKey;
        const myPendingEvents: any[] = [];
        myPendingEventResponse.map((item: any) => {
          let dateEnd = moment(item.end, 'YYYY-MM-DD HH:mm')
          if (dateEnd.isAfter()) {
            return myPendingEvents.push({
              title: 'Attesa di conferma',
              start: item.start,
              end: item.end,
              allDay: false,
              eventType: EventType.MyPendingEvent,
              visibleRange: {
                start: moment.utc(item.start).local().format('HH:mm'),
                end: moment.utc(item.end).local().format('HH:mm'),
              },
            });
          }
        });
        state.myPendingEvents[room] = {
          ...state.myPendingEvents[room],
          [month]: myPendingEvents,
        };
        state.events[room] = {
          ...state.events[room],
          [month]: getRoomMonthEvents(state, room, month),
        };
      }
      state.loading = false;
    },
    getSpecificRoomAndMonthCustomerDataErrorAction: (state, action) => {
      state.loading = false;
      state.myPendingEvents = {};
      state.bookedIntervals = {};
      state.error = action.payload;
    },
    addCustomerEventAction: (state, action) => {
      const event = action.payload;
      const product = event.product
      if (!state.customerEvents[product]) {
        state.customerEvents[product] = [event];
      } else {
        state.customerEvents[product].push(event);
      }
      state.events[product] = {
        ...state.events[product],
        [event.month]: getRoomMonthEvents(state, product, event.month),
      };
    },
    addSelectedDateCalendarEventAction: (state, action) => {
      const event = action.payload;
      const product = action.payload.product;
      const selectedDateEvent = []
      selectedDateEvent.push(event)
      state.selectedDateEvent[product] = {
        ...state.selectedDateEvent[product],
        [event.month]: selectedDateEvent,
      };
      state.events[product] = {
        ...state.events[product],
        [event.month]: getRoomMonthEvents(state, product, event.month),
      };
    },
    deleteSelectedDateCalendarAction: (state, action) => {
      const eventToDelete = action.payload;
      const product = eventToDelete.product
      state.selectedDateEvent = {}
      state.events[product] = {
        [eventToDelete.month]: getRoomMonthEvents(state, product, eventToDelete.month),
      };
    },
    updateCustomerEventAction: (state, action) => {
      const updatedEvent = action.payload;
      const product = updatedEvent.product
      const customerEvents = state.customerEvents[product].map(
        (event: any) => {
          return updatedEvent.id === event.id ? updatedEvent : event;
        },
      );
      state.customerEvents[product] = customerEvents;
      state.events[product] = {
        [updatedEvent.month]: getRoomMonthEvents(state, product, updatedEvent.month),
      };
    },
    deleteCustomerEventAction: (state, action) => {
      const eventToDelete = action.payload;
      const product = eventToDelete.product
      const customerEvents: any = [];
      state.customerEvents[product].map((event: any) => {
        return eventToDelete.id === event.id
          ? null
          : customerEvents.push(event);
      });
      state.customerEvents[product] = customerEvents;
      state.events[product] = {
        [eventToDelete.month]: getRoomMonthEvents(state, product, eventToDelete.month),
      };
    },
    sendBookingAction: (state, action) => {
      state.loading = true;
      state.error = null;
      state.bookingSent = false;
    },
    sendBookingSuccessAction: (state) => {
      state.loading = false;
      state.error = null;
      state.bookingSent = true;
      state.customerEvents = {};
    },
    sendBookingErrorAction: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getAllEventsAction: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getAllEventsSuccessAction: (state, action) => {
      state.loading = false;
      state.error = null;
      const allEventsResponse = action.payload.allEventsResponse.data.data;
      const room = action.payload.room
      const monthKey = action.payload.monthKey;
      const allEvents: any[] = [];
      allEventsResponse.map((item: any) => {
        return allEvents.push({
          id: item.id,
          title: item.booking ? item.booking.user_information?.full_name : i18n.t('booking.missingData'),
          start: item.start,
          end: item.end,
          allDay: false,
          eventType: EventType.ReadOnlyEvent,
          selectedDate: moment.utc(item.start).format('YYYY-MM-DD'),
          eventData: item,
          layout: item.layout,
          remote_attendees: item.remote_attendees,
          payment_method: item.payment_method,
          operator_management_choice: item.operator_management_choice,
          description: item.description,
          attendees: item.attendees,
          services: item.services,
          visibleRange: {
            start: moment.utc(item.start).local().format('HH:mm'),
            end: moment.utc(item.end).local().format('HH:mm'),
          },
        });
      });
      state.events[room] = {
        ...state.events[room],
        [monthKey]: allEvents,
      };
    },
    getAllEventsErrorAction: (state, action) => {
      state.loading = false;
      state.bookedIntervals = {};
      state.error = action.payload;
    },
    setCustomerEventsAction: (state, action) => {
      const reservation = action.payload
      const allCustomerEvents = reservation.interval;
      const customerEvents: any = {}
      allCustomerEvents.map((item: any) => {
        const eventData = {
          ...item,
          booking: reservation
        }
        const event = {
          id: item.id,
          title: 'Da richiesta cliente',
          start: item.start,
          end: item.end,
          product: item.product,
          allDay: false,
          eventType: item.check_in || moment.utc(item.start).isBefore(moment().utc()) && reservation.status !== 'SENT' ? EventType.ReadOnlyEvent : EventType.CustomerEvent,
          eventData: eventData,
          description: item.description,
          attendees: item.attendees,
          services: item.services,
          layout: item.layout,
          remote_attendees: item.remote_attendees,
          payment_method: item.payment_method,
          operator_management_choice: item.operator_management_choice,
          selectedDate: moment.utc(item.start).format('YYYY-MM-DD'),
          visibleRange: {
            start: moment.utc(item.start).local().format('HH:mm'),
            end: moment.utc(item.end).local().format('HH:mm'),
          },
        }
        if (customerEvents[item.product]) {
          customerEvents[item.product].push(event)
        } else {
          customerEvents[item.product] = [event]
        }
      })
      state.customerEvents = customerEvents
    },
    getCustomerEventsAction: (state, action) => {
      state.error = null;
      const room = action.payload.room
      const monthKey = action.payload.monthKey;
      state.events[room] = {
        ...state.events[room],
        [monthKey]: state.customerEvents[room],
      };
    },
    makeReservationResetState: () => initialState,
  },
});

export const filteredServices = createSelector(
  [state => state.roomsAndServices, (state, idRoom, selectedServices) => idRoom, (state, idRoom, selectedServices) => selectedServices],
  (roomsAndServices: any, idRoom: any, selectedServices: any) => {
    const toReturn: any = [{ id: '', name: i18n.t('booking.selectService') }];
    let selectedRoomServices = roomsAndServices.find((room: any) => room.id === idRoom.id).services
    selectedRoomServices.map((service: any) => toReturn.push(service));
    return toReturn.filter((service: any) => !selectedServices.some((selectedService: any) => service.id === selectedService.id))
  },
);

export const {
  getRoomsAndServicesAction,
  getRoomsAndServicesSuccessAction,
  getRoomsAndServicesErrorAction,
  getSpecificRoomAndMonthBookedIntervalsAction,
  getSpecificRoomAndMonthBookedIntervalsSuccessAction,
  getSpecificRoomAndMonthBookedIntervalsErrorAction,
  getSpecificRoomAndMonthCustomerDataAction,
  getSpecificRoomAndMonthMyPendingEventsSuccessAction,
  getSpecificRoomAndMonthCustomerDataErrorAction,
  addCustomerEventAction,
  updateCustomerEventAction,
  deleteCustomerEventAction,
  sendBookingAction,
  sendBookingSuccessAction,
  sendBookingErrorAction,
  getAllEventsAction,
  getAllEventsSuccessAction,
  getAllEventsErrorAction,
  setCustomerEventsAction,
  getCustomerEventsAction,
  makeReservationResetState,
  addSelectedDateCalendarEventAction,
  deleteSelectedDateCalendarAction
} = slice.actions;

export default slice.reducer;
